import { useIntl } from 'react-intl'
import { Link as MUILink } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { structureSearchDrawRoute, searchResultsRoute } from '@src/routes'
import { Link } from '@src/components/Link'
import messages from '@utils/messages'
import { sendSearchInteractionEvent } from '@src/utils/analytics'

const useStyles = makeStyles()((theme) => ({
  container: {
    margin: theme.spacing(4, 0, 4, 0),
  },
  sectionHeading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  sectionText: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '1.5rem',
    listStylePosition: 'inside',
    textIndent: '-20px',
    margin: '0',
    marginLeft: '20px',
    padding: '0',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.8rem',
    },
  },
  textLink: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
}))

const SearchTips = () => {
  const { formatMessage } = useIntl()
  const { classes } = useStyles()
  return (
    <section className={classes.container}>
      <h4 className={classes.sectionHeading}>
        {formatMessage(messages.SEARCH_TIPS)}
      </h4>
      <ul className={classes.sectionText}>
        <li>{formatMessage(messages.WORDS_SPELLED_CORRECTLY)}</li>
        <li>{formatMessage(messages.REMOVE_SPACES)}</li>
        <li>{formatMessage(messages.TRY_REPHRASING)}</li>
        <li>
          {formatMessage({ id: 'TRY_OUR', defaultMessage: 'Try our' })}{' '}
          <Link href={structureSearchDrawRoute.index()} passHref>
            <MUILink
              className={classes.textLink}
              onClick={() => {
                sendSearchInteractionEvent({
                  action: 'visit chemical structure search',
                  component: 'body',
                  elementType: 'link',
                  elementText: 'structure search',
                  linkUrl: structureSearchDrawRoute.index(),
                  section: 'search tips',
                })
              }}
            >
              {formatMessage({
                id: 'STRUCTURE_SEARCH',
                defaultMessage: 'Structure Search',
              })}{' '}
            </MUILink>
          </Link>
          {formatMessage(messages.OR)}{' '}
          <Link href={searchResultsRoute.index()} passHref>
            <MUILink
              className={classes.textLink}
              onClick={() => {
                sendSearchInteractionEvent({
                  action: 'visit advanced search page',
                  component: 'body',
                  elementType: 'link',
                  elementText: 'advanced search',
                  linkUrl: searchResultsRoute.index(),
                  section: 'search tips',
                })
              }}
            >
              {formatMessage({
                id: 'ADVANCED_SEARCH',
                defaultMessage: 'Advanced Search',
              })}{' '}
            </MUILink>
          </Link>
          {formatMessage(messages.TOOL)}
        </li>
      </ul>
    </section>
  )
}

export default SearchTips
